import React, { useEffect } from 'react';
import { useStore } from '@nanostores/react';
import { cartData } from '@stores/cartStore';

const NostoInit = () => {
	let $cartData = useStore(cartData || null);

	useEffect(() => {
		if ($cartData && $cartData.lines) {
			let items = $cartData.lines;
			const nostoCartLines = items.map((line) => {
				const productId = line.node.merchandise.product.id;
				const productIdNumber = productId.split('/').pop();
				const skuId = line.node.merchandise.id;
				const skuIdNumber = skuId.split('/').pop();
				return {
					name: line.node.merchandise.product.title,
					price_currency_code: 'USD',
					product_id: productIdNumber,
					quantity: line.node.quantity,
					sku_id: skuIdNumber,
					unit_price: Number(line.node.cost.totalAmount.amount),
				};
			});

			nostojs((api) => {
				api.defaultSession()
					.setCart({
						items: nostoCartLines,
					})
					.viewCart()
					.update()
					.then((response) => {
						// Handle the response here
						return response;
					})
					.catch((error) => {
						console.error('Nosto cart update error:', error);
					});
			});
		}
	}, [$cartData]);
};

export default NostoInit;
